/* Endo theme runtime: cart, collection filtering, product form, browsing memory. */
(function () {
  var E = window.Endo || {}, R = E.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function money(cents) {
    var fmt = E.money || '${{amount}}';
    var s = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function track(n, p) { if (window.posthog && window.posthog.capture) window.posthog.capture(n, p); }
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4.5 4.5L19 7"/></svg>' + document.createTextNode(msg).textContent.replace(/[<>&]/g, ''); t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-empty', !n);
      el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
    });
  }
  function drawerEl() { return $('[data-cart-drawer]'); }
  function openDrawer() {
    var d = drawerEl(); if (!d) return false;
    d.classList.add('is-open'); document.body.style.overflow = 'hidden';
    var up = $('[data-drawer-upsell]', d);
    if (up && up.hidden) fillDrawerUpsell();
    return true;
  }
  function closeDrawer() { var d = drawerEl(); if (d) d.classList.remove('is-open'); document.body.style.overflow = ''; }
  function refreshDrawer() {
    if (!drawerEl()) return Promise.resolve();
    return fetch(R.root + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var nu = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      var cur = drawerEl(); if (!nu || !cur) return;
      if (cur.classList.contains('is-open')) nu.classList.add('is-open');
      cur.replaceWith(nu);
      fillDrawerUpsell();
    });
  }
  /* One-tap upsell above the checkout button: related parts not already in the cart. */
  function fillDrawerUpsell() {
    var d = drawerEl(); if (!d) return;
    var box = $('[data-drawer-upsell]', d), rec = d.getAttribute('data-rec-url');
    if (!box || !rec) return;
    fetch(R.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) { box.hidden = true; return; }
      var have = c.items.map(function (i) { return i.handle; });
      return fetch(rec + '?section_id=product-addons&product_id=' + c.items[0].product_id + '&limit=4&intent=related')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var picks = Array.prototype.filter.call(doc.querySelectorAll('.addon'), function (n) {
            var a = n.querySelector('a[href]');
            var h = a ? (a.getAttribute('href') || '').split('?')[0].split('/').pop() : '';
            return have.indexOf(h) === -1;
          }).slice(0, 2);
          var list = $('[data-drawer-upsell-list]', box);
          if (!picks.length || !list) { box.hidden = true; return; }
          var frag = document.createDocumentFragment();
          picks.forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
          list.replaceChildren(frag);
          box.hidden = false;
        });
    }).catch(function () { box.hidden = true; });
  }
  function addToCart(id, qty) {
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { if (!r.ok) throw r; return fetch(R.cart + '.js'); }).then(function (r) { return r.json(); })
      .then(function (c) {
        setCartCount(c.item_count);
        track('add_to_cart', { variant_id: id, quantity: qty || 1, cart_size: c.item_count });
        return refreshDrawer().then(function () { if (!openDrawer()) toast(E.strings.added); });
      });
  }
  function addItems(items) {
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return fetch(R.cart + '.js'); }).then(function (r) { return r.json(); })
      .then(function (c) {
        setCartCount(c.item_count);
        track('add_to_cart', { items: items.length, cart_size: c.item_count });
        return refreshDrawer().then(function () { if (!openDrawer()) toast(E.strings.added); });
      });
  }
  E.addItems = addItems;
  /* Serializes the whole product form so app-injected fields (file uploads,
     custom options) ride along as line item properties. */
  function addForm(f) {
    var fd = new FormData(f);
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw r; return fetch(R.cart + '.js'); }).then(function (r) { return r.json(); })
      .then(function (c) {
        setCartCount(c.item_count);
        track('add_to_cart', { variant_id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1, cart_size: c.item_count });
        return refreshDrawer().then(function () { if (!openDrawer()) toast(E.strings.added); });
      });
  }
  function skeletons(n) {
    var h = '';
    for (var i = 0; i < n; i++) h += '<div class="card card--skeleton" aria-hidden="true"><div class="card__media sk"></div><div class="card__body"><span class="sk sk--line" style="width:38%"></span><span class="sk sk--line" style="width:86%"></span><span class="sk sk--line" style="width:28%"></span></div></div>';
    return h;
  }

  /* Header and nav */
  var navBtn = $('[data-nav-toggle]'), nav = $('#MobileNav');
  if (navBtn && nav) navBtn.addEventListener('click', function () {
    var on = nav.hidden; nav.hidden = !on; navBtn.setAttribute('aria-expanded', String(on));
  });

  /* Collection and search: filters, sort, skeleton swap via Section Rendering API */
  var col = $('[data-collection]');
  if (col) {
    var sectionId = col.getAttribute('data-section-id');
    var toggle = $('[data-facets-toggle]', col), panel = $('[data-facets-panel]', col);
    if (toggle) toggle.addEventListener('click', function () { var on = panel.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', String(on)); });
    var t;
    function load(url) {
      var grid = $('[data-product-grid]', col);
      grid.innerHTML = skeletons(Math.min(grid.children.length || 12, 12));
      col.classList.add('is-loading');
      var u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-product-grid]', '[data-facets]', '[data-results-count]', '.pagination'].forEach(function (sel) {
          var nu = doc.querySelector(sel), old = $(sel, col);
          if (old && nu) old.replaceWith(nu); else if (old && !nu) old.remove();
          else if (nu && sel === '.pagination') $('[data-product-grid]', col).after(nu);
        });
        history.pushState({}, '', url);
        col.classList.remove('is-loading');
      }).catch(function () { location.href = url; });
    }
    function fromForm() {
      var f = $('[data-facets]', col); if (!f) return;
      var fd = new FormData(f), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      load(f.getAttribute('action') + '?' + p.toString());
    }
    col.addEventListener('change', function (e) {
      if (e.target.matches('[data-facets] input[type=checkbox]')) fromForm();
      else if (e.target.matches('[data-facets] input[type=number]')) { clearTimeout(t); t = setTimeout(fromForm, 500); }
      else if (e.target.matches('[data-sort]')) { var f = $('[data-facets] [name=sort_by]', col); if (f) f.value = e.target.value; fromForm(); }
    });
    col.addEventListener('click', function (e) {
      var a = e.target.closest('.pagination a, .facets__clear'); if (!a) return;
      e.preventDefault(); load(a.getAttribute('href'));
      if (a.closest('.pagination')) col.scrollIntoView({ behavior: 'smooth' });
    });
    window.addEventListener('popstate', function () { load(location.href); });
    var handle = col.getAttribute('data-handle');
    if (handle) {
      var rc = store.get('endo_rc', []).filter(function (x) { return x.h !== handle; });
      rc.unshift({ h: handle, title: col.getAttribute('data-title'), url: col.getAttribute('data-url'), ts: Date.now() });
      store.set('endo_rc', rc.slice(0, 6));
    }
  }

  /* Product page */
  var prod = $('[data-product]');
  if (prod) {
    var variants = JSON.parse($('[data-variants]', prod).textContent || '[]');
    var form = $('[data-product-form]', prod), idInput = $('[data-variant-id]', prod);
    var selects = $$('[data-option-index]', prod);
    function currentVariant() {
      var opts = selects.map(function (s) { return s.value; });
      return variants.find(function (v) { return opts.every(function (o, i) { return v.options[i] === o; }); });
    }
    function applyVariant(v) {
      var add = $('[data-add]', prod), txt = $('[data-add-text]', prod);
      if (!v) { add.disabled = true; txt.textContent = E.strings.unavailable; return; }
      idInput.value = v.id;
      var skuEl = $('[data-sku]', prod); if (skuEl) skuEl.textContent = v.sku || '';
      $('[data-price]', prod).innerHTML = v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> <span class="price--sale">' + money(v.price) + '</span>' : money(v.price);
      add.disabled = !v.available; txt.textContent = v.available ? E.strings.addToCart : E.strings.soldOut;
      if (v.featured_image && v.featured_image.src) {
        var img = $('[data-main-image]', prod);
        if (img) { var src = v.featured_image.src; img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; img.srcset = ''; }
        $$('[data-thumb]', prod).forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-media-position') === String(v.featured_image.position)); });
      }
      var st = $('[data-stock]', prod);
      if (st) {
        var low = parseInt(st.getAttribute('data-low'), 10) || 5, q = v.inventory_quantity;
        var isLow = v.inventory_management && q > 0 && q <= low;
        st.textContent = v.available ? (st.getAttribute('data-order-label') || (isLow ? E.strings.onlyLeft.replace('8888', q) : E.strings.inStock)) : '';
        st.classList.remove('is-ok', 'is-low');
        if (v.available) st.classList.add(isLow ? 'is-low' : 'is-ok');
      }
      var sp = $('[data-sticky-price]', prod); if (sp) sp.textContent = money(v.price);
      var ss = $('[data-sticky-sku]', prod); if (ss) { ss.textContent = v.sku || ''; ss.hidden = !v.sku; }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    selects.forEach(function (s) { s.addEventListener('change', function () { applyVariant(currentVariant()); }); });
    $$('[data-thumb]', prod).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-thumb]', prod).forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active');
        var img = $('[data-main-image]', prod); if (img) { img.src = b.getAttribute('data-thumb'); img.srcset = ''; }
      });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add]', prod); btn.disabled = true; btn.classList.add('is-loading');
      addForm(form)
        .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); })
        .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); form.submit(); });
    });
    var bar = $('[data-stickybar]', prod), buy = $('.product__buy', prod);
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var x = en[0]; bar.hidden = x.isIntersecting || x.boundingClientRect.top > 0;
      }).observe(buy);
      $('[data-sticky-add]', prod).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
    /* Remember this part */
    var h = prod.getAttribute('data-handle'), fits = [];
    try { fits = JSON.parse(prod.getAttribute('data-fits') || '[]').filter(Boolean); } catch (e) {}
    var rv = store.get('endo_rv', []).filter(function (x) { return x.h !== h; });
    rv.unshift({ h: h, t: fits, ts: Date.now() }); store.set('endo_rv', rv.slice(0, 24));
    track('product_viewed', { handle: h, fits: fits });
    var ad = $('[data-addons]', prod);
    if (ad) {
      var adBase = ad.getAttribute('data-base'), adPid = ad.getAttribute('data-product-id'), adLim = ad.getAttribute('data-limit') || 3;
      var adList = $('[data-addons-list]', ad);
      var loadAddons = function (intent) {
        return fetch(adBase + '?section_id=product-addons&product_id=' + adPid + '&limit=' + adLim + '&intent=' + intent)
          .then(function (r) { if (!r.ok) throw r; return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('.addon') ? doc : null;
          });
      };
      ad.hidden = false;
      loadAddons('complementary')
        .then(function (doc) { return doc || loadAddons('related'); })
        .then(function (doc) {
          if (!doc) { ad.hidden = true; return; }
          var frag = document.createDocumentFragment();
          doc.querySelectorAll('.addon').forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
          adList.replaceChildren(frag);
          track('addons_shown', { product_id: adPid });
        })
        .catch(function () { ad.hidden = true; });
    }
  }

  /* Quantity steppers (product and cart) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty],[data-line-qty]'); if (!b) return;
    var inp = $('.qty__input', b.closest('.qty')); var d = parseInt(b.getAttribute('data-qty') || b.getAttribute('data-line-qty'), 10);
    inp.value = Math.max(parseInt(inp.min || 0, 10), (parseInt(inp.value, 10) || 0) + d);
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page */
  var cart = $('[data-cart]');
  if (cart) {
    function change(line, qty) {
      cart.classList.add('is-loading');
      fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function () { return fetch(location.pathname + '?section_id=' + cart.closest('.shopify-section').id.replace('shopify-section-', '')); })
        .then(function (r) { return r.text(); })
        .then(function (html) { var doc = new DOMParser().parseFromString(html, 'text/html'); var nu = doc.querySelector('[data-cart]'); if (nu) cart.replaceWith(nu); cart = $('[data-cart]'); return fetch(R.cart + '.js'); })
        .then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); })
        .catch(function () { location.reload(); });
    }
    document.addEventListener('change', function (e) { var i = e.target.closest('[data-line-input]'); if (i) change(parseInt(i.getAttribute('data-line-input'), 10), parseInt(i.value, 10) || 0); });
    document.addEventListener('click', function (e) { var b = e.target.closest('[data-remove]'); if (b) change(parseInt(b.getAttribute('data-remove'), 10), 0); });
  }

  /* Adaptive home: recently viewed, inferred bike, recent collections */
  var rvSec = $('[data-recently-viewed]');
  if (rvSec) {
    var current = prod ? prod.getAttribute('data-handle') : null;
    var list = store.get('endo_rv', []).filter(function (x) { return x.h !== current; });
    var limit = parseInt(rvSec.getAttribute('data-limit'), 10) || 8;
    if (list.length >= 2 || (prod && list.length >= 1)) {
      var grid = $('[data-rv-grid]', rvSec), tpl = $('[data-rv-card]', rvSec);
      var histHeading = rvSec.getAttribute('data-history-heading');
      if (histHeading) $('[data-rv-title]', rvSec).textContent = histHeading;
      var link = $('[data-rv-link]', rvSec); if (link) link.hidden = true;
      grid.innerHTML = skeletons(Math.min(list.length, limit));
      var fit = E.fitPrefix || 'fits:';
      Promise.allSettled(list.slice(0, limit).map(function (x) { return fetch(R.root + 'products/' + x.h + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }); }))
        .then(function (rs) {
          var frag = document.createDocumentFragment();
          rs.forEach(function (r) {
            if (r.status !== 'fulfilled') return;
            var p = r.value, n = tpl.content.cloneNode(true);
            $$('[data-url]', n).forEach(function (a) { a.href = R.root + 'products/' + p.handle; });
            var img = $('[data-img]', n);
            if (p.featured_image) { img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2'); img.alt = p.title; } else img.remove();
            var fits = (p.tags || []).filter(function (t) { return t.indexOf(fit) === 0; }).map(function (t) { return t.slice(fit.length).trim(); }).join(' / ');
            var f = $('[data-fits]', n); if (fits) { f.textContent = fits; f.hidden = false; }
            $('[data-title]', n).textContent = p.title;
            $('[data-price]', n).innerHTML = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s> <span class="price--sale">' + money(p.price) + '</span>' : money(p.price);
            frag.appendChild(n);
          });
          if (frag.childNodes.length) grid.replaceChildren(frag); else rvSec.hidden = true;
        });
    } else if (prod) rvSec.hidden = true;
  }

  var hero = $('[data-hero]');
  if (hero) {
    var rcWrap = $('[data-recent-collections]', hero), rcList = store.get('endo_rc', []);
    if (rcWrap && rcList.length) {
      rcList.slice(0, 4).forEach(function (c) { rcWrap.insertAdjacentHTML('beforeend', '<a class="chip" href="' + c.url + '">' + c.title.replace(/[<>&]/g, '') + '</a>'); });
      rcWrap.hidden = false;
    }
  }

  /* Life: staggered reveal and typing search examples */
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduced) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); ro.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8%' });
    $$('.grid--cards > *, .grid--tiles > *, .quote, .prop').forEach(function (el, i) {
      el.classList.add('rv'); el.style.transitionDelay = (i % 4) * 70 + 'ms'; ro.observe(el);
    });
  }
  var hi = $('[data-search-open-input]');
  if (hi) {
    var phrases = (hi.getAttribute('data-type-examples') || '').split('\n').map(function (t) { return t.trim(); }).filter(Boolean);
    if (phrases.length && !reduced) {
      var basePh = hi.placeholder, pi = 0, ci = 0, deleting = false, stopType = false;
      hi.addEventListener('focus', function () { stopType = true; hi.placeholder = basePh; });
      (function tick() {
        if (stopType) return;
        var word = phrases[pi % phrases.length];
        ci += deleting ? -1 : 1;
        hi.placeholder = word.slice(0, ci) || basePh;
        var wait = deleting ? 32 : 64;
        if (!deleting && ci === word.length) { deleting = true; wait = 1500; }
        else if (deleting && ci === 0) { deleting = false; pi++; wait = 300; }
        setTimeout(tick, wait);
      })();
    }
  }

  /* Cart drawer and quick add */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault(); q.disabled = true; q.classList.add('is-loading');
      addToCart(q.getAttribute('data-quick-add'), 1)
        .catch(function () { toast(E.strings.unavailable); })
        .then(function () { q.disabled = false; q.classList.remove('is-loading'); });
    }
  });
  /* Program forms: send the section's analytics event on submit. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-track-submit]');
    if (f) track(f.getAttribute('data-track-submit') || 'form_submitted', { path: location.pathname });
  });
  document.addEventListener('keydown', function (e) { var d = drawerEl(); if (e.key === 'Escape' && d && d.classList.contains('is-open')) closeDrawer(); });
  document.addEventListener('click', function (e) { if (e.target.closest('[name=checkout]')) track('checkout_started', { cart_size: parseInt((drawerEl() || {}).getAttribute && drawerEl().getAttribute('data-count'), 10) || undefined }); });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-d-line-input]'); if (!i) return;
    fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(i.getAttribute('data-d-line-input'), 10), quantity: parseInt(i.value, 10) || 0 }) })
      .then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); return refreshDrawer(); })
      .catch(function () { location.reload(); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-d-remove]'); if (!b) return;
    var inp = $('[data-d-line-input="' + b.getAttribute('data-d-remove') + '"]');
    if (inp) { inp.value = 0; inp.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* Related products */
  var rec = $('[data-recommendations]');
  if (rec) fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
    var nu = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rec-grid]');
    if (!nu || !nu.querySelector('.card:not(.card--skeleton)')) { rec.hidden = true; return; }
    $('[data-rec-grid]', rec).replaceWith(nu);
  }).catch(function () { rec.hidden = true; });
})();

/* Affiliate links: ?ref=CODE (or ?aff=CODE) remembers the code for 30 days,
   auto-applies the matching discount code, and stamps the cart attribute
   "Affiliate" so every order records which code brought the rider in. */
(function () {
  var KEY = 'endo_aff', DAYS = 30;
  function valid(code) { return typeof code === 'string' && /^[A-Za-z0-9][A-Za-z0-9._-]{1,39}$/.test(code); }
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && valid(v.code) && typeof v.ts === 'number' && v.ts <= Date.now() && (Date.now() - v.ts) < DAYS * 864e5 ? v : null; } catch (e) { return null; } }
  function save(code) { try { localStorage.setItem(KEY, JSON.stringify({ code: code, ts: Date.now() })); } catch (e) {} }
  var params = new URLSearchParams(location.search);
  var requested = params.get('ref') || params.get('aff');
  var fresh = valid(requested) ? requested : null;
  if (fresh) save(fresh);
  // A newly opened referral still works when the browser blocks local storage.
  var aff = fresh ? { code: fresh, ts: Date.now() } : read();
  if (!aff) return;
  if (fresh && window.posthog && window.posthog.capture) window.posthog.capture('affiliate_visit', { code: aff.code });
  var done = null; try { done = sessionStorage.getItem(KEY + '_applied'); } catch (e) {}
  var discount = done === aff.code && !fresh ? Promise.resolve() : fetch('/discount/' + encodeURIComponent(aff.code)).then(function (response) {
    if (!response.ok) throw new Error('Discount could not be applied.');
  });
  // A completed checkout can create a new cart in the same browser session.
  // Stamp the current cart even when its discount was already applied this session.
  var attribution = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { Affiliate: aff.code } }) }).then(function (response) {
    if (!response.ok) throw new Error('Referral could not be saved.');
  });
  Promise.all([discount, attribution])
    .then(function () { try { sessionStorage.setItem(KEY + '_applied', aff.code); } catch (e) {} })
    .catch(function () {});
})();
